import React, { createContext, useContext, useState, useEffect } from "react";

const AppStateContext = createContext(null);

const PROVIDER_ID_STORAGE_KEY = "selectedAiProviderId";
const MODEL_TIER_STORAGE_KEY = "selectedAiModelTier";
const DEFAULT_STORED_MODEL_TIER = "medium";

const readStoredString = (key, fallback = "") => {
  try {
    const saved = localStorage.getItem(key);
    return saved != null && saved !== "" ? saved : fallback;
  } catch {
    return fallback;
  }
};

export function useAppState() {
  return useContext(AppStateContext);
}

export function AppStateProvider({ children }) {
  const [activeMode, setActiveMode] = useState(null);
  const [sessionId, setSessionId] = useState(null);
  const [useWebSearch, setUseWebSearch] = useState(() => {
   
    try {
      const saved = localStorage.getItem("useWebSearch");
      return saved ? JSON.parse(saved) : true;
    } catch (error) {
      return true;
    }
  });
  const [selectedProviderId, setSelectedProviderId] = useState(() =>
    readStoredString(PROVIDER_ID_STORAGE_KEY),
  );
  const [selectedModelTier, setSelectedModelTier] = useState(() =>
    readStoredString(MODEL_TIER_STORAGE_KEY, DEFAULT_STORED_MODEL_TIER),
  );


  useEffect(() => {
    try {
      localStorage.setItem("useWebSearch", JSON.stringify(useWebSearch));
    } catch (error) {
      return false;
    }
  }, [useWebSearch]);

  useEffect(() => {
    try {
      if (selectedProviderId) {
        localStorage.setItem(PROVIDER_ID_STORAGE_KEY, selectedProviderId);
      } else {
        localStorage.removeItem(PROVIDER_ID_STORAGE_KEY);
      }
    } catch {
      /* ignore quota / private mode */
    }
  }, [selectedProviderId]);

  useEffect(() => {
    try {
      localStorage.setItem(
        MODEL_TIER_STORAGE_KEY,
        selectedModelTier || DEFAULT_STORED_MODEL_TIER,
      );
    } catch {
      /* ignore quota / private mode */
    }
  }, [selectedModelTier]);

  const goHome = (navigate, clearMessages) => {
    setActiveMode(null);

    if (clearMessages) {
      clearMessages([]);
    }

    if (navigate) navigate("/");
  };

  return (
    <AppStateContext.Provider
      value={{
        activeMode,
        setActiveMode,
        sessionId,
        setSessionId,
        goHome,
        useWebSearch,
        setUseWebSearch,
        selectedProviderId,
        setSelectedProviderId,
        selectedModelTier,
        setSelectedModelTier,
      }}
    >
      {children}
    </AppStateContext.Provider>
  );
}
